module.exports = __webpack_public_path__ + "static/najiaxiaoguan-64086be5319e007b0072d907b77418b8.png";